import React from 'react';

// ─── VERSION FOOTER ───────────────────────────────────────────────────────────
// Shows the deployed build's git SHA + build timestamp (UTC), injected at
// build time (see package.json's "build" script). Makes it obvious whether
// a given browser tab is running the latest deploy.

export default function VersionFooter() {
  const sha  = process.env.REACT_APP_GIT_SHA;
  const date = process.env.REACT_APP_BUILD_DATE;
  if (!sha) return null;

  return (
    <div style={{
      textAlign: 'center', fontSize: 11, color: 'var(--gray)',
      opacity: 0.6, padding: '8px 0 16px',
    }}>
      Build {sha}{date ? ` · ${date}` : ''}
    </div>
  );
}
